import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { formatAmountForDisplay } from "Utilities/Amount/formatAmountForDisplay";

PartiallyRefundedInfo.propTypes = {
  payment: PropTypes.object,
};

export default function PartiallyRefundedInfo({ payment }) {
  const { refunds } = payment;

  const formatAmount = (amount) => {
    return formatAmountForDisplay(amount, {
      isCents: true,
      includeDollarSign: true,
    });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString("en-us", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Wrapper>
      <Title>Original Payment</Title>
      <Entry>
        <SDate>{formatDate(payment.date)}</SDate>
        <Amount>{formatAmount(payment.amount)}</Amount>
      </Entry>

      <div style={{ marginBottom: 6 }} />

      <Title>{refunds.length === 1 ? "Refund" : "Refunds"}</Title>
      {refunds.map((r, i) => (
        <Entry key={`${r.date}-${i}`}>
          <SDate>{formatDate(r.date)}</SDate>
          <Amount>{formatAmount(r.amount)}</Amount>
        </Entry>
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
`;

const Entry = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 15px;
`;

const Amount = styled.div``;

const SDate = styled.div``;
